<template>
	<div>
    <div style="position: fixed; top: 50px; bottom: 68px; min-width: 350px; max-width: 350px; overflow-y: auto !important;" :class="{'with_subheader': is_subheader,'with_twosubheader': is_twosubheader}">
    	<slot></slot>
    </div>
 		<v-toolbar color="grey darken-4" fixed dense right style="top: 0px; left: auto;">
 			<slot name="header"></slot>
    </v-toolbar>
    <div v-if="is_subheader" style="margin-top: 50px;">
	    <slot name="subheader"></slot>
	    <v-divider></v-divider>
	   </div>
	   <div v-if="is_twosubheader" style="margin-top: 50px;">
	    <slot name="twosubheader"></slot>
	    <v-divider></v-divider>
	  </div>
	</div>
</template>

<script>
export default {

	data() {
		return {
			is_subheader: false,
			is_twosubheader: false,
			is_header: false
		}
	},
	mounted() {
		if (typeof(this.$slots.subheader) != "undefined") {
			this.is_subheader = true;
		}
		if (typeof(this.$slots.twosubheader) != "undefined") {
			this.is_twosubheader = true;
		}


		if (typeof(this.$slots.header) != "undefined") {
			this.is_header = true;
		}
	}

}
</script>

<style scoped>
.with_subheader {
	margin-top: 50px;
}
.with_twosubheader {
	margin-top: 100px;
}
</style>
